<template>
	<div class="card-inner">
		<div class="alert alert-info">
			<strong>Global Chapter Settings</strong><br />
			These settings apply to all chapters across all projects and inspections.
			Individual inspections can still override these settings.
		</div>

		<table class="table table-sm">
			<thead>
				<tr>
					<th>Chapter</th>
					<th style="text-align: center">New Page</th>
					<th style="text-align: center">Hide Page</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="chapter in chapterList" :key="chapter.id">
					<td>
						<strong>{{ chapter.cap }}</strong> - {{ chapter.title }}
					</td>
					<td style="text-align: center">
						<div class="custom-control custom-checkbox">
							<input
								type="checkbox"
								class="custom-control-input"
								:id="'newpage-' + chapter.id"
								v-model="chapter.settings.newpage"
							/>
							<label
								class="custom-control-label"
								:for="'newpage-' + chapter.id"
							></label>
						</div>
					</td>
					<td style="text-align: center">
						<div class="custom-control custom-checkbox">
							<input
								type="checkbox"
								class="custom-control-input"
								:id="'hide-' + chapter.id"
								v-model="chapter.settings.hideProgressBar"
							/>
							<label
								class="custom-control-label"
								:for="'hide-' + chapter.id"
							></label>
						</div>
					</td>
					<td style="text-align: right">
						<button
							class="btn btn-sm btn-primary"
							@click="saveChapterSetting(chapter)"
						>
							Save
						</button>
					</td>
				</tr>
			</tbody>
		</table>

		<div style="margin-top: 20px">
			<button class="btn btn-lg btn-primary" @click="saveAllSettings">
				Save All Settings
			</button>
		</div>
	</div>
</template>

<script>
import {
	getGlobalChapterSettings,
	saveGlobalChapterSettings,
} from '@/services/reporting-v3.service';

export default {
	name: 'GlobalChapterSettings',
	data() {
		return {
			chapterList: [
				{
					cap: 'A',
					id: 'inspectionDetails',
					title: 'Inspection Details',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B',
					id: 'general',
					title: 'General',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B.1',
					id: 'generalB1',
					title: 'General B.1',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B.2',
					id: 'generalB2',
					title: 'General B.2',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B.3',
					id: 'generalB3',
					title: 'General B.3',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B.4',
					id: 'generalB4',
					title: 'General B.4',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'B.5',
					id: 'generalB5',
					title: 'General B.5',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'C',
					id: 'machinedata',
					title: 'Machine Data',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'D',
					id: 'components',
					title: 'Components',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'E',
					id: 'findings',
					title: 'Findings',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'F',
					id: 'conclusion',
					title: 'Conclusion',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
				{
					cap: 'G',
					id: 'disclaimer',
					title: 'Disclaimer',
					settings: {
						newpage: false,
						hideProgressBar: false,
					},
				},
			],
			loading: false,
		};
	},
	methods: {
		async loadGlobalSettings() {
			try {
				const response = await getGlobalChapterSettings();

				if (response && response.data && response.data.settings) {
					// Merge loaded settings with chapter list
					for (const chapter of this.chapterList) {
						const savedSetting = response.data.settings.find(
							(s) => s.chapterId === chapter.id
						);
						if (savedSetting && savedSetting.settings) {
							chapter.settings = {
								...chapter.settings,
								...savedSetting.settings,
							};
						}
					}
				}
			} catch (error) {
				console.error('Error loading global settings:', error);
				// Continue with default settings
			}
		},

		async saveChapterSetting(chapter) {
			this.loading = true;
			try {
				await saveGlobalChapterSettings(chapter.id, chapter.settings);

				this.$swal('Success', 'Chapter setting saved successfully', 'success');
			} catch (error) {
				console.error('Error saving setting:', error);
				this.$store.dispatch('api_error', error);
			}
			this.loading = false;
		},

		async saveAllSettings() {
			this.loading = true;

			try {
				const promises = this.chapterList.map((chapter) =>
					saveGlobalChapterSettings(chapter.id, chapter.settings)
				);

				await Promise.all(promises);

				this.$swal(
					'Success',
					'All global chapter settings saved successfully',
					'success'
				);
			} catch (error) {
				console.error('Error saving settings:', error);
				this.$store.dispatch('api_error', error);
			}

			this.loading = false;
		},
	},

	mounted() {
		this.loadGlobalSettings();
	},
};
</script>

<style scoped>
.custom-control-label {
	cursor: pointer;
}

.table td {
	vertical-align: middle;
}
</style>
